import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import http from './../../../../services/Api'
import swal from 'sweetalert';

import 'react-phone-number-input/style.css'
import './index.css'
import { RiLoader4Line } from 'react-icons/ri';

function EditUserForm({ data }) {
  const [loading, setLoading] = useState(false)
  const { register, handleSubmit, setValue } = useForm();
  const query = new URLSearchParams(window.location.search);
  const id = query.get('id');

  useEffect(() => {
    init()
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  const init =  async() => {
    setValue('name', data.name)
    setValue('username', data.username)
    setValue('email', data.email)
  }

  const save = async data => {
    const { email, name, username } = data
    try {
      setLoading(true)
      await http.post(`/api/user/update/${id}`, {
        name,
        username,
        email,
      })
      swal("Sucesso!", `Perfil editado com sucesso`, "success")
      setLoading(false);
    } catch (e) {
      console.log(e)
    }
  };

  return (
    <div className="EditUser-Form">
      <h1>Editar Usuário</h1>
      <Form method="POST" onSubmit={handleSubmit(save)}>
        <Form.Group as={Row} controlId="name">
          <Form.Label column sm="2">
            Nome
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" name="name" ref={register} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="Username">
          <Form.Label column sm="2">
            Usuário
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" name="username" ref={register} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="email">
          <Form.Label column sm="2">
            Email
          </Form.Label>
          <Col sm="10">
            <Form.Control type="text" name="email" ref={register} />
          </Col>
        </Form.Group>
        <Button variant="primary" type="submit">
          {loading ?
            <RiLoader4Line className="spin" />
            :
            'Salvar'
          }
        </Button>
      </Form>
    </div>
  );
}

export default EditUserForm;